import styled from "styled-components";

interface ImageProps {
	imageurl?: string | null;
}
export const PageContainer = styled.div`
	width: 100%;
	height: 100%;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 20px 15%;
	border-bottom-width: 1px !important;
	border-bottom-style: solid;
	border-color: #e0e0e0;
	align-items: center;
	@media (max-width: 699px) {
		padding: 15px 10%;
	}
	@media (max-width: 550px) {
		padding: 10px 5%;
	}
`;

export const LogoWrapper = styled.div`
	width: 80px;
	height: 80px;
	display: flex;
	align-items: center;

	@media (max-width: 699px) {
		width: 100px;
		height: 100px;
	}
	@media (max-width: 550px) {
		width: 60px;
		height: 60px;
	}
`;
export const Image = styled.div<ImageProps>`
	width: 100%;
	height: 100%;
	background-image: url(${(p) => p.imageurl});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
`;
export const WrapperContainer = styled.div`
	display: flex;
	justify-content: space-between;
	@media (max-width: 1100px) {
		flex-direction: column-reverse;
		justify-content: center;
		align-items: center;
	}
`;
export const ContentCard = styled.div`
	border-radius: 10px;
	background: white;
	padding: 60px;
	@media (max-width: 699px) {
		padding: 30px;
	}
`;
export const DescrContainer = styled.div`
	margin-right: 10px;
	width: 55%;
	padding: 10px 20px 10px 0px;
	font-size: 18px;
	line-height: 1.5;
	@media (max-width: 1100px) and (min-width: 699px) {
		padding: 10px;
		width: 90%;
		margin-top: 20px;
	}
	@media (max-width: 699px) {
		padding: 10px 0px;
		width: 100%;
		font-size: 15px;
		margin-top: 20px;
	}
	@media (max-width: 550px) {
		font-size: 13px;
	}
`;
export const ImageWrapper = styled.div`
	width: 350px;
	height: 350px;
	padding-top: 20px;
	@media (max-width: 1100px) and (min-width: 699px) {
		width: 80%;
	}
	@media (max-width: 699px) {
		width: 250px;
		height: 250px;
		margin: 0 auto;
	}
`;
export const TitleTag = styled.div`
	font-weight: bold;
	font-size: 30px;
	color: #495057;
	margin-bottom: 20px;
	@media (max-width: 1100px) {
		text-align: center;
		padding-left: 0px;
	}
	@media (max-width: 699px) {
		width: 100%;
		font-size: 25px;
		margin-bottom: 0px;
	}
	@media (max-width: 550px) {
		font-size: 20px;
		margin-bottom: 0px;
	}
`;
export const BodyContainer = styled.div`
	padding: 30px 15%;
	width: 100%;
	height: 100%;
	@media (max-width: 699px) {
		padding: 30px 10%;
	}
	@media (max-width: 550px) {
		padding: 30px 5%;
	}
`;
